function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

export default (function (_ref) {
  _objectDestructuringEmpty(_ref);

  return {};
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/IconTheme.js
// module id = 1071
// module chunks = 1